import { ProfileMin } from '../../shared/profile-min.model';
import { Component, OnInit, Input, OnChanges } from '@angular/core';
import { RelationTypeService } from '../../shared/relation-type.service';
import { RelationTypeSearchParams } from '../../shared/relation-type-search-params.model';
import { RelationType } from '../../shared/relation-type-model';
import { ProfileService } from '../../shared/profile.service';
import { ProfileRelationshipManagementDto } from '../../shared/dto/profile-relationship-management.dto';
import { ProfileRelationSearch } from '../../shared/profile-relation-search.model';
import { UserService } from 'src/app/users/shared/user.service';

// ==============
// When editing this component, you might see that ProfileID & RelProfileID are inverted -
// this is to make it load correctly without rebuilding it completely
// ==============

@Component({
  selector: 'wl-profile-edit-relationship',
  templateUrl: './profile-edit-relationship.component.html',
  styleUrls: ['./profile-edit-relationship.component.css'],
    standalone: false
})
export class ProfileEditRelationshipComponent implements OnInit, OnChanges {
  private _pristineValue = '';

  public profileRelation: ProfileRelationshipManagementDto;
  public relationTypes: Array<RelationType>;
  public selectedRelationType: RelationType;
  public relatedProfileAccess: number = 0;

  @Input() relatedProfileId: number;
  @Input() profileId: number;
  @Input() profileRelationId: number;

  constructor(
    private _profileService: ProfileService,
    private _relationTypeService: RelationTypeService,
    private _userService: UserService
  ) {
    this.profileRelation = {} as ProfileRelationshipManagementDto;
  }

  ngOnInit() {
    this._relationTypeService.search(<RelationTypeSearchParams>{ PageNumber: 0, PageSize: 0 }).then((data) => {
      this.relationTypes = data.Result;
      this.relationTypes.sort((a, b) => {
        return a.RelationType.toLowerCase().localeCompare(b.RelationType.toLowerCase());
      });
      this.selectedRelationType = this.relationTypes[0];
    });
    this._userService.getCurrentUserSecurityElementAccessLevel('ProfileRelated_Profiles_Tab').then((accessLevel: number) => {
      this.relatedProfileAccess = accessLevel;
    });
  }

  ngOnChanges() {
    if (this.profileRelationId) {
      this.getRelatedProfile();
    }
    if (this.profileId) {
      this.profileRelation.ProfileID = this.relatedProfileId;
      this._profileService.getProfileMin(this.profileId).then((relProfile: ProfileMin) => {
        this.profileRelation.ReportName = relProfile.ReportName;
      });
    }
    if (this.relatedProfileId) {
      this.profileRelation.RelProfileID = this.profileId;
      this._profileService.getProfileMin(this.relatedProfileId).then((profile: ProfileMin) => {
        this.profileRelation.ParentReportName = profile.ReportName;
      });
    }
  }

  setPristine() {
    this._pristineValue = '';
    this._pristineValue = JSON.stringify(this.profileRelation);
  }

  public getRelatedProfile() {
    const search = new ProfileRelationSearch();
    search.ProfileId = this.relatedProfileId;
    search.RelProfileID = this.profileId;
    search.RelationID = this.profileRelationId;
    this._profileService.getProfileRelationsForManagement(search).then((data) => {
      if (data) {
        const relation = data.Result[0];
        this.profileRelation = relation;
        this.selectedRelationType = this.relationTypes.find((x) => x.RelationTypeId === relation.InvRelationTypeID);

        this.setPristine();
      } else {
        this.profileRelation = {} as ProfileRelationshipManagementDto;
        this.profileRelation.ProfileID = this.relatedProfileId;
        this.profileRelation.RelProfileID = this.profileId;

        this._profileService.getProfileMin(this.relatedProfileId).then((profile: ProfileMin) => {
          this.profileRelation.ParentReportName = profile.ReportName;
        });

        this._profileService.getProfileMin(this.profileId).then((relProfile: ProfileMin) => {
          this.profileRelation.ReportName = relProfile.ReportName;
        });
      }
    });
  }

  public save(): Promise<void> {
    if (this.selectedRelationType && this.selectedRelationType.InvRelationType) {
      this.profileRelation.RelationType = this.selectedRelationType.InvRelationType;
    }
    if (this.selectedRelationType && this.selectedRelationType.InvRelationTypeId) {
      this.profileRelation.RelationTypeID = this.selectedRelationType.InvRelationTypeId;
    }

    let currentRelationJson = JSON.stringify(this.profileRelation);
    let dirty: boolean = this._pristineValue != currentRelationJson;

    if (dirty && this.profileRelation.ProfileID && this.profileRelation.RelProfileID) {
      this.setPristine();

      return this._profileService.upsertProfileRelation(this.profileRelation);
    } else {
      return Promise.resolve<void>(null);
    }
  }

  relationTypeChanged() {
    if (!this.selectedRelationType.PrimaryRelation) {
      this.profileRelation.ReceivesCommunication = false;
    }
  }
}
